<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('mannes')"
          :directory="[$t('mannes'), $t('manne')]"
          :icon="'users'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="text-sm-right mb-primary mb-sm-0 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="openModal()"
          >
            {{ $t("add_manne") }}
          </button>
        </div>
      </div>
    </div>
    <app-table :id="tableId" :options="options" @action="getAction" />

    <app-manne-modal
      v-if="isManneModalActive"
      :table-id="tableId"
      :selected-url="selectedUrl"
      @close-modal="closeModal"
    />
  
    <app-confirmation-modal
      v-if="confirmationModalActive"
      modal-id="manne-delete-modal"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />
 
   
   
  </div>
</template>
<script>
import CoreLibrary from "@core/helpers/CoreLibrary.js";
import { collection, urlGenerator } from "@app/Helpers/helpers";
import { mapGetters } from "vuex";
import { owner, manneType, manneCate } from "@app/Mixins/Global/FilterMixins";
import { DeleteMixin } from "@app/Mixins/Global/DeleteMixin";
export default {
  name: "Manne",
  extends: CoreLibrary,
  mixins: [owner, manneType, manneCate, DeleteMixin],
  data() {
    return {
      urlGenerator,
      isManneModalActive: false,
      isContactModalActive: false,
      tableId: "manne-modal",
      contacttableId: "contact-modal",
      confirmationModalActive: false,
      isQuickViewModalActive: false,
      organizationModal: false,
      manneActivitiesModal: false,
      editedUrl: "",
      viewAllDeal: false,
      viewAllFollower: false,
      isNoteModal: false,
      noteRowData: null,
      manneId: null,
      selectedUrl: "",
      activityData: {},
      followerUrl: "",
      manneFundData: {},
      
      options: {
        name: this.$t("manne_table"),
        url: "crm/mannes",
        showHeader: true,
        countView: true,
        columns: [
        
        {
          title: this.$t("id"),
          type: "custom-html",
		  key: "id",
          modifier: (value, row) => {
			  return value;
          },
        },
		 {
          title: this.$t("manne_cate"),
          type: "custom-html",
          key: "cate",
          modifier: (value, row) => {
            return value
              ? `<span class="badge badge-pill badge-${value.class ?? "secondary"}">${
                  value.name
                }</span>`
              : "-";
          },
        },
		 {
          title: this.$t("lead_group"),
          type: "custom-html",
          key: "manne_type",
          modifier: (value, row) => {
            return value
              ? `<span class="">${
                  value.name
                }</span>`
              : "-";
          },
        },
	    
				
				
		
	
		   {
          title: this.$t("fund_storage"),
          type: "custom-html",
          key: "fund",
          modifier: (value, row) => {
            return value
              ? '<a href="/crm/funds/'+value.id+'/edit"><u>'+value.name+': '+('00000' + value.id).slice(-5)+'</u></a>'
              : "-";
          },
        },
       
		  
		
		  
		    {
          title: this.$t("size"),
          type: "custom-html",
          key: "size",
          modifier: (value, row) => {
            return value
              ? `<span>${
                  value
                }</span>`
              : "-";
          },
        },
      
        {
          title: this.$t("action"),
          type: "action",
          key: "invoice",
          isVisible: true,
        },
      ],
        filters: [
       
          {
            title: this.$t("manne_cate"),
            type: "checkbox",
            key: "manne_cate",
            option: [],
          },
          {
            title: this.$t("lead_group"),
            type: "checkbox",
            key: "manne_type",
            option: [],
          },
          {
            title: this.$t("with_fund"),
            type: "radio",
            key: "with_fund",
            option: [
            {
                id: 1,
                name: this.$t('filtr_with_fund'),
              },
            {
                id: 2,
                name: this.$t('filtr_without_fund'),
              },
            ],
            listValueField: "name",
          },
			
		
         
        ],
        showSearch: true,
        showFilter: true,
        paginationType: "pagination",
        responsive: false,
        rowLimit: 50,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
        actions: [
          /*{
            title: this.$t("quick_view"),
            icon: "zap",
            type: "modal",
            component: "app-manne-quick-view",
            modalId: "quickViewModal",
            url: "",
          },*/
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "modal",
            component: "app-manne-modal",
            modalId: "manne-modal",
            url: "",
          },
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "modal",
            component: "app-confirmation-modal",
            modalId: "manne-delete-modal",
            url: "",
          },
          {
            title: this.$t("delete_fund"),
            icon: "trash",
            type: "modal",
            url: "",
          },
        ],
      },
    };
  },
  methods: {
	  
	
    getAction(rowData, actionObj, active) {
      if (actionObj.title == this.$t("edit")) {
        this.selectedUrl = `crm/mannes/${rowData.id}`;
        this.isManneModalActive = true;
      } else if (actionObj.title == this.$t("delete")) {
        this.deleteUrl = `crm/mannes/${rowData.id}`;
        this.confirmationModalActive = true;
      } else if (actionObj.title == this.$t("delete_fund")) {
        this.deleteFund(rowData.id);
      }
    },
    openModal() {
      this.isManneModalActive = true;
    },


    closeModal() {
      this.isManneModalActive = false;
      this.selectedUrl = "";
      $("#manne-modal").modal("hide");
    },

  
    deleteFund(id){

      
      this.manneFundData.id = id;
      this.manneFundData.change = 1;
      this.manneFundData.fund_id = null;
      

      this.axiosPatch({
        url: '/crm/mannes/' + id,
        data: this.manneFundData,
      }).then((response) => {
        this.$toastr.s(response.data.message);
            this.errors = {}
            this.$emit('update-request');
            this.$hub.$emit('reload-' + this.tableId);

      }).catch(({ response }) => {

      }).finally(() => {


      });


    },

 
   

  },
  computed: {

  },
  mounted() {
    this.$store.dispatch('manneType');
    this.$store.dispatch('manneCate');
  },
};
</script>
<style>
.link-list {
  white-space: nowrap !important;
  max-width: 180px;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
